<div class="flex shrink-0 grow-0 flex-row items-center gap-2">
  <mat-icon
    class="icon-xs shrink-0"
    [fontSet]="fontSet()"
    [ngClass]="iconClass()"
  >
    {{ icon() }}
  </mat-icon>
  @if (!iconOnly()) {
    <div class="pr-0.5 text-xs"><ng-content /></div>
  }
</div>
